import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import env from '../enviorments'
import header from '../header'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        token: null,
        user: null,
    },
    getters: {

    },
    mutations: {
        mutateUser(state, user) {
            state.user = user
        },
        mutateToken(state, token) {
            state.token = token
        },
    },
    actions: {
        //Auth
        async userLogin({commit}, user) {
            const result = (await axios.post(env.apiUrl + 'auth/authenticate', {...user})).data
            if (result.success == false) return {"success": false, "data": [], "message": result.message, "error": []}
            window.localStorage.setItem('token', JSON.stringify(result.result.token))
            window.localStorage.setItem('user', JSON.stringify(result.result.agent))
            commit('mutateToken', result.result.token)
            commit('mutateUser', result.result.agent)

            return {"success": true, "data": result.result.agent, "message": "login is success.", "error": []}
        },
        //Dashboard
        async dashboardAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'dashboard', {headers: header.getToken()})).data
            if (result.status == false) return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async agentDashboardAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'agents/agent-dashboard', {headers: header.getToken()})).data
           if (result.success == false) return {"success": false, "data": [], "message": result.message, "error": []}
                return {"success": true, "data": result.result, "message": "Success", "error": []}
        },
        //Agent List
        async agentListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-agents/agent-lists', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },

        async agentStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'master-agents/add-agent',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },

        async agentDetailAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-agents/agent-details', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },

        async agentUpdateAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'master-agents/update-agent',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },

        async agentDeleteAction({commit}, option) {
            const result = (await axios.post(env.apiUrl + 'agent-delete', {...option}, {headers: header.getToken()})).data
            if (result.status == false) return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },

        //Bank Info
        async paymentMethodAction({commit}) {
            const responseData = (await axios.get(env.apiUrl + 'master-bank-infos/get-payment-methods', {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async bankListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-bank-infos/get-bank-infos', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async bankStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'master-bank-infos/add-bank-info',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },

        async bankDetailAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-bank-infos/bank-info-details', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },

        async bankUpdateAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'master-bank-infos/update-bank-info',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },

        async bankDeleteAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-bank-infos/delete-bank-info', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.response.data.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },

        async agentBankListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-bank-infos/agent-bank-details', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },

        async getAgentBanks({commit}, option) {
            const responseData = (await axios.get(env.apiUrl + 'agents/get-agent-banks', {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },

        async agentBankStoreAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'master-bank-infos/add-agent-bank',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },

        async agentBankUpdateAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'master-bank-infos/update-agent-bank',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
        
                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },

        // Deposit
        async depositListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-coins/deposit-lists', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async depositStatusCompletedAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-coins/approve-deposit', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.response.data.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async depositStatusFailedAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-coins/reject-deposit', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.response.data.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        // Withdraw
        async withdrawListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-coins/withdraw-lists', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async withdrawStatusCompletedAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-coins/approve-withdraw', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.response.data.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        async withdrawStatusFailedAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-coins/reject-withdraw', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.response.data.message, "error": []}
            return {"success": true, "data": responseData.data, "message": "Success", "error": []}
        },
        // Member
        async memberListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-agents/user-lists', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async agentMemberListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'agents/user-lists', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        // Report
        async dailyReportListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-agents/daily-report', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async agentReportListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'master-agents/agent-report', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async memberReportListAction({commit}, option) {
            console.log("Option:", option)
            const responseData = (await axios.post(env.apiUrl + 'master-agents/member-report', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async memberWinLoseReportListAction({commit}, option) {
            console.log("Option:", option)
            const responseData = (await axios.post(env.apiUrl + 'master-agents/member-winlose-report', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async agentDailyReportListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'agents/daily-report', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async agentMemberReportListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'agents/member-report', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async agentMemberWinLoseReportListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'agents/member-winlose-report', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async totalAgentDailySummaryAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'agents/total-daily-summary', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async totalAgentMemberSummaryAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'agents/total-member-summary', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        //Agent Request Withdraw
         async agentPaymentMethodAction({commit}) {
            const responseData = (await axios.get(env.apiUrl + 'agents/get-payment-methods', {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
         async getAgentCommissionAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'agents/get-commission', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async agentRequestWithdrawListAction({commit}, option) {
            const responseData = (await axios.post(env.apiUrl + 'agents/commission-history', {...option}, {headers: header.getToken()})).data
            if (responseData.success == false) return {"success": false, "data": [], "message": responseData.message, "error": []}
            return {"success": true, "data": responseData.result, "message": "Success", "error": []}
        },
        async agentRequestWithdrawAction({commit}, option) {
            try {
                // Check if option is a FormData object
                if (!(option instanceof FormData)) {
                    throw new Error('Option is not a FormData object');
                }
        
                // Proceed with axios POST request
                const result = await axios.post(
                    env.apiUrl + 'agents/withdraw-commission',
                    option,
                    {
                        headers: {
                            ...header.getToken(),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                return { "success": true, "data": result.data, "message": "Success", "error": [] };
            } catch (error) {
                console.error('Error in Store Action:', error);
                return { "success": false, "data": [], "message": error.response.data.message, "error": [error] };
            }
        },
    },
    modules: {
    }
})
